'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  SEO_QUERY
} from "./chunk-W3K3QG4J.mjs";
import {
  RICHTEXT_QUERY
} from "./chunk-G62SUGCR.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  OTHER_BOOKING_OPTIONS_QUERY
} from "./chunk-6KZWPHJX.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  requestWithRateLimitHandling
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/detail.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getEventDetail($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
  eventCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      __typename
      sys { id }
      id
      title
      subtitle
      description{${RICHTEXT_QUERY}}
      eventLogo{${IMAGE_QUERY}}
      slug
      ticketingUrlSlug
      image11{${IMAGE_QUERY}}
      image31{${IMAGE_QUERY}}
      startingPrice
      currencyCode
      schedule{${SCHEDULE_QUERY}}
      isStreamingEvent
      zoneEntryIncluded
      streamingUrl 
      buttonLabel
      cardButtonLabel
      eventType
      authGaurd
      buttonLink
      cmsTagsCollection(limit: 10){
        items {${TAG_QUERY}}
      }
      buyLiveStream{
        id
        title
        description
        currencyCode
        startingPrice
        taxInfo
        limitations
        layout
        button {
          title
          type
          label
          link
        }
      }
      carousalCollection(limit: 60) {
        items {${IMAGE_QUERY}}
      }
      artistsCollection(limit: 10) {
        items {
          name
          thumbnail {${IMAGE_QUERY}}
          subtitle
        }
      }
      season{title slug}
      zone{
        id slug title zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}} 
      }
      location{${LOCATION_QUERY}}
      category{id title slug}
      sponsorsCollection(limit: 20) {
        items {
          id
          title
          titleColor
          sponsorsCollection(limit: 20) {
            items {
              id
              title
              logo {${IMAGE_QUERY}}
              link
            }
          }
        }
      }
      isComingSoon
      richTerms { json }
      whatToKnow
      specialPromotion
      showResellBanner
      seo{${SEO_QUERY}}
      otherBookingSection {${OTHER_BOOKING_OPTIONS_QUERY}}
      organizationSlug
      visibility
    }
  }
}
`;
var getEventDetail = (props) => __async(void 0, null, function* () {
  var _a, _b, _c;
  try {
    const res = yield requestWithRateLimitHandling(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang)
    }));
    return {
      data: (_b = (_a = res.eventCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0],
      rateLimited: (_c = res.rateLimited) != null ? _c : false
    };
  } catch (error) {
    throw new Exception({ error, name: "getEventDetailException" });
  }
});
var useGetEventDetail = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getEventDetail", props],
    queryFn: () => getEventDetail(props)
  }));
};

export {
  getEventDetail,
  useGetEventDetail
};
//# sourceMappingURL=chunk-D4FAMCD3.mjs.map